import styled from 'styled-components';

export const PictureNode = styled.picture`
  > img {
    width: 100%;
    height: auto;
  }
`;
